import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Paper, Stack, Tab, Tabs, Typography } from '@mui/material';
import { getLeaderboard } from '../api';
import { useLang } from '../i18n';

const MEDALS = ['🥇', '🥈', '🥉'];

function Board({ data, period }) {
  const { t } = useLang();
  if (!data.top.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
        {period === 'today' ? t('board.emptyToday') : t('board.emptyWeek')}
      </Typography>
    );
  }
  return (
    <Box>
      {data.top.map((row) => (
        <Stack key={row.rank} direction="row"
          sx={{ py: 0.75, px: 1, borderRadius: 1, alignItems: 'center',
                bgcolor: row.is_me ? 'action.selected' : 'transparent' }}>
          <Typography sx={{ width: 32 }}>{MEDALS[row.rank - 1] || `${row.rank}.`}</Typography>
          <Typography sx={{ flex: 1, fontWeight: row.is_me ? 600 : 400 }}>
            {row.name || t('board.student')}{row.is_me ? t('board.you') : ''}
          </Typography>
          <Typography color="text.secondary">{t('board.min', { m: row.minutes })}</Typography>
        </Stack>
      ))}
      {data.me && data.me.rank > data.top.length && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, px: 1 }}>
          {t('board.yourPlace', { r: data.me.rank, m: data.me.minutes })}
          {data.me.gap_minutes ? t('board.gap', { g: data.me.gap_minutes }) : ''}
        </Typography>
      )}
      {!data.me && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, px: 1 }}>{t('board.join')}</Typography>
      )}
    </Box>
  );
}

export default function Leaderboard() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [period, setPeriod] = useState('today');

  useEffect(() => {
    getLeaderboard().then(setData).catch(() => setData(null));
  }, []);

  if (!data) return null;
  return (
    <Paper variant="outlined" sx={{ p: 2, width: '100%', borderRadius: 2 }}>
      <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{t('board.title')}</Typography>
        <Link component={RouterLink} to="/study" variant="body2">{t('board.study')}</Link>
      </Stack>
      <Tabs value={period} onChange={(_, v) => setPeriod(v)} sx={{ minHeight: 36, mb: 1 }}>
        <Tab value="today" label={t('board.today')} sx={{ minHeight: 36 }} />
        <Tab value="week" label={t('board.week')} sx={{ minHeight: 36 }} />
      </Tabs>
      <Board data={data[period]} period={period} />
      <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1 }}>
        {t('board.note')}
      </Typography>
    </Paper>
  );
}
